<template>
  <div class="pd-10" ref="replyForm">
    <div class="row no-gutters">
      <div class="col-8">
        <textarea
          v-model="execModel.execution"
          class="form-control"
          rows="2"
          placeholder="Хариу"
        ></textarea>
      </div>
      <div class="col-4">
        <simpleUploader
          :key="upldrKey"
          @on-success="onSuccess($event)"
        ></simpleUploader>
      </div>
    </div>

    <button
      @click="sendExecution"
      type="button"
      class="btn btn-xs btn-secondary btn-block"
    >
      Илгээх
    </button>
  </div>
</template>

<script>
import { postExecution } from "@/api/taskInUser";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  name: "forumTopicReply",
  components: {
    simpleUploader: () => ({
      component: import("@/components/modules/media/uploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    taskId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      dialog: false,
      upldrKey: 0,
      execModel: {
        taskId: this.taskId,
        //perc: this.execModel.perc,
        execution: "",
        planTypeId: null,
        //planTypeId: this.execModel.planTypeId,
        //attachmentId: this.execModel.attachmentId,
        attachmentId: null
      }
    };
  },
  mounted() {
    this.$emit("on-height", this.$refs.replyForm.offsetHeight);
  },
  methods: {
    sendExecution() {
      let errs = [];
      if (
        this.execModel.execution.length <= 0 &&
        this.execModel.attachmentId == null
      ) {
        errs.push("Тэмдэглэл хоосон байна !");
      }

      if (errs.length == 0) {
        postExecution({ data: this.execModel, store: this.$store }).then(
          res => {
            if (res != false) {
              this.$emit("on-posted", { taskId: this.taskId, id: res.data.id });
              this.execModel = {
                taskId: this.taskId,
                execution: "",
                planTypeId: null,
                attachmentId: null
              };
              this.upldrKey++;
            }
          }
        );
      } else {
        this.$bvToast.toast(errs[0], {
          title: "Мэдэгдэл",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "warning",
          toaster: "b-toaster-bottom-right"
        });
      }
    },
    onSuccess(e) {
      //console.log(e);
      this.execModel.attachmentId = e.uploadedAttachmentId;
    }
  }
};
</script>
